export const step2 = {
  email: {
    value: '',
    isValid: false,
  },
  repeatEmail: {
    value: '',
    isValid: false,
  },
  phone: {
    value: '',
    isValid: false,
  },
  streetAddress: {
    value: '',
    isValid: false,
  },
  addressLevel2: {
    value: '',
    isValid: false,
  },
  addressLevel3: {
    value: '',
    isValid: false,
  },
  region: {
    value: '',
    isValid: false,
  },
  commune: {
    value: '',
    isValid: false,
  },
  omdmResponse: {
    value: null,
    isValid: false,
  },
};